module.exports = __webpack_public_path__ + "img/103053.6ff22963.png";